import { render, staticRenderFns } from "./WpReview.vue?vue&type=template&id=d5294aee&"
import script from "./WpReview.vue?vue&type=script&lang=js&"
export * from "./WpReview.vue?vue&type=script&lang=js&"
import style0 from "./WpReview.vue?vue&type=style&index=0&id=d5294aee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports